var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.column_chart_options)?_c('Chart',{attrs:{"options":_vm.column_chart_options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }